var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bto-livestream-player","data-video-only":_vm.isOnlyVideo}},[(_vm.providerId === _vm.STREAM_PROVIDERS.Oddin && _vm.oddinUrl)?_c('iframe',{style:(_vm.oddinStyle),attrs:{"src":_vm.oddinUrl,"allowfullscreen":""}}):_c('video',{ref:"bto-live-player",staticClass:"video-js vjs-big-play-centered"})])
}
var staticRenderFns = []

export { render, staticRenderFns }